const footerLinks = [
  { id: "must-watch", label: "本周必看榜" },
  { id: "high-rated", label: "高分电影精选" },
  { id: "trending", label: "热门电影" },
  { id: "genres", label: "按类型找片" },
  { id: "new-releases", label: "新片速递" },
  { id: "guide", label: "观影指南" },
  { id: "faq", label: "常见问题" },
];

export default function Footer() {
  return (
    <footer className="bg-accent-900">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-14 md:px-6 md:py-16">
        <div className="flex flex-col gap-10 lg:flex-row lg:items-start lg:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-accent-800">
                <i className="ri-film-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                风驰影院
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-accent-100">
              专注整理电影推荐与排行榜，把必看片单、高分电影和热门作品放在一页。
              希望每一次「今晚看什么」，都能在这里找到答案。
            </p>
          </div>

          <div className="grid grid-cols-2 gap-x-8 gap-y-3 sm:grid-cols-3 lg:max-w-xl">
            {footerLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                className="cursor-pointer font-label text-sm text-accent-100 transition-colors hover:text-background-50"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-accent-700/60 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-label text-xs text-accent-200">
            本页片单与评分为整理性质的观影参考，仅用于选片交流，不提供在线播放、下载或任何资源链接。
          </p>
          <p className="font-label text-xs text-accent-200 whitespace-nowrap">
            © 2026 风驰影院 · 观影指南
          </p>
        </div>
      </div>
    </footer>
  );
}